import { render, staticRenderFns } from "./UserProfileCreate.vue?vue&type=template&id=54c5dafb&"
import script from "./UserProfileCreate.vue?vue&type=script&lang=js&"
export * from "./UserProfileCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports